import { gql } from "@apollo/client";

const GET_VALIDITIES = gql`
  query GetValidities {
    validities {
      count
      items {
        label
        value
      }
    }
  }
`;

export default GET_VALIDITIES;
